// Б.2.c: Хирург без лицензии — триггер «Когда владелец разыгрывает Мод».
//
// Каждый раз, когда владелец Хирурга РАЗЫГРЫВАЕТ карту-Мод (на любого своего
// юнита, в т.ч. на самого Хирурга): Герой владельца лечится на 1 ХП С
// ПРЕВЫШЕНИЕМ ЛИМИТА максимума, Хирург получает 1 урон себе.
//
// Что считается «розыгрышем»:
//   - revealPendingMods вызывает attachMod с source.isPlayed=true.
//   - Триггеры (Раст-passive, Нарколаборатория) вызывают attachMod с
//     source.isPlayed=false (или без isPlayed) — Хирург НЕ реагирует.
//
// Каскад:
//   - Если 2 Хирурга на поле — оба реагируют (2 хила Герою, 1+1 урон каждому).
//   - Если Хирург умирает от своего урона — обычная смерть (dispatchUnitDied).
//   - Если в матче два игрока с Синтетиксом — каждый Хирург реагирует только
//     на Моды СВОЕГО владельца (мы итерируем по владельцу разыгранного Мода).

import { applyDamage } from '../../combat.js';
import { dispatchUnitDied } from '../deus/hooks.js';
import { shortHeroName } from '../../../data/heroes.js';

export const CARD_ID = 'syn_hirurg_bez_litsenzii';

// Вызывается из attachMod после успешного прикрепления, ТОЛЬКО когда
// source.isPlayed=true (то есть это розыгрыш карты-Мода игроком, не триггер).
//
// Б.2.c-fix1: -1 ХП Хирургу идёт через стандартный applyDamage — без clamp'ов
// и через тот же путь, что и любой другой урон (Броня поглощает, dispatchUnitDied
// активирует Посмертия Эксп. батареи / Второго сердца / deathrattle).
export function hirurgOnModPlayed(state, ownerIdx) {
  const p = state.players[ownerIdx];
  // Снимок: учитываем только Хирургов, живых на момент входа. Если их 2,
  // оба реагируют (даже если первый убьёт себя — второй всё равно отработает).
  const hirurgi = p.unitsOnField().filter(u => u.id === CARD_ID && u.isAlive());
  if (hirurgi.length === 0) return;
  for (const h of hirurgi) {
    if (!h.isAlive()) continue;
    // Хил Героя +1 С ПРЕВЫШЕНИЕМ лимита (по правилу карты).
    const beforeHero = p.hero.current.hp;
    p.hero.current.hp = beforeHero + 1;
    state.log.add(
      `🩹 ${h.name_ru} [${p.name}]: Розыгрыш Мода → ${shortHeroName(p.hero)} +1 HP ` +
      `(HP ${beforeHero}→${p.hero.current.hp}, превышение лимита разрешено), ${h.name_ru} -1 HP`
    );
    // Урон 1 себе через стандартный applyDamage (Броня поглощает).
    applyDamage(h, 1, { pierce: false });
    if (h.current.hp <= 0) {
      h.alive = false;
      p.removeFromField(h);
      state.log.add(`✗ ${h.name_ru} [${p.name}] погибает (Хирург закончился)`);
      dispatchUnitDied(state, {
        ownerIdx, card: h,
        killer: null, killerIdx: null, killerWasCounter: false
      });
    }
  }
}
